import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestAddressDto, RequestAddressiewDto } from '../dto/address.dto';


@Injectable()
export class AddressNestApi {

  private service: string = '';
  private model: string = 'Address';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: RequestAddressDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public view(payload: RequestAddressiewDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'view';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/address.api.ts